import React from 'react';

// When anything throws during render, React unmounts the whole tree — which is why a
// crash shows up as a completely blank white page with only a minified stack in the
// console. That is almost impossible to diagnose from a bug report. This boundary
// catches it instead and shows the real error message, the component stack (which
// says exactly which component failed), and a way back, so a crash is reportable in
// one screenshot rather than a round trip of guesses.
export class ErrorBoundary extends React.Component {
  constructor(props){
    super(props);
    this.state={error:null,info:null};
  }
  static getDerivedStateFromError(error){
    return {error};
  }
  componentDidCatch(error,info){
    this.setState({info});
    // Still log it — the console keeps the full stack with source-map resolution.
    console.error("App crashed:",error,info&&info.componentStack);
  }
  render(){
    if(!this.state.error)return this.props.children;
    const {error,info}=this.state;
    const detail=[
      String(error&&error.message||error),
      "",
      (error&&error.stack)||"",
      "",
      "Component stack:",
      (info&&info.componentStack)||"(unavailable)",
    ].join("\n");
    return(
      <div style={{minHeight:"100vh",background:"#0f172a",color:"#e2e8f0",padding:"28px 20px",fontFamily:"system-ui,-apple-system,sans-serif"}}>
        <div style={{maxWidth:760,margin:"0 auto"}}>
          <div style={{fontSize:20,fontWeight:800,marginBottom:6}}>Something went wrong</div>
          <div style={{fontSize:13,color:"#94a3b8",lineHeight:1.6,marginBottom:16}}>
            The page hit an unexpected error. Nothing you did caused this. Reloading usually
            gets you going again — if it keeps happening, copying the details below into a bug
            report tells us exactly what broke.
          </div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:16}}>
            <button onClick={()=>window.location.reload()} style={{padding:"9px 16px",borderRadius:8,border:"none",background:"#10b981",color:"#fff",fontWeight:700,fontSize:13,cursor:"pointer"}}>Reload the app</button>
            <button onClick={()=>{try{navigator.clipboard.writeText(detail);}catch(e){}}} style={{padding:"9px 16px",borderRadius:8,border:"1px solid #334155",background:"none",color:"#e2e8f0",fontWeight:700,fontSize:13,cursor:"pointer"}}>Copy error details</button>
          </div>
          <pre style={{background:"#020617",border:"1px solid #1e293b",borderRadius:10,padding:14,fontSize:11,lineHeight:1.6,whiteSpace:"pre-wrap",wordBreak:"break-word",overflowX:"auto",maxHeight:"55vh"}}>{detail}</pre>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
